<template>
  <v-btn
    class="msr msr--loader"
    :dark="!disabled"
    :disabled="disabled"
    :loading="loading"
    :round="round"
    :large="large"
    @click="$emit('click')"
  >
    <v-icon
      v-if="!label || labelWithIcon"
      medium
    >
      {{ icon }}
    </v-icon>
    <div
      v-if="labelWithIcon"
      class="mr-2"
    />
    <div v-if="!icon || label || labelWithIcon">
      {{ label }}
    </div>
  </v-btn>
</template>

<script>
export default {
  name: 'BtnOk',
  props: {
    icon: {
      type: String,
      default: 'check',
    },
    label: {
      type: String,
      default: null,
    },
    labelWithIcon: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    round: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
/* Force white spinner color on button inside a light toolbar. */
button.msr--loader {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ButtonOk.vue